module.exports = __webpack_public_path__ + "img/calendar.0f365af3.svg";